import Mask from './mask.js';

class RemapCoordMask extends Mask {
    constructor(width, height, targetMask, remapper) {
        super();

        this._width = width;
        this._height = height;
        this._targetMask = targetMask;
        this._remapper = remapper;

        this._oldWidth = null;
        this._oldHeight = null;
        this._oldTargetWidth = null;
        this._oldTargetHeight = null;
        this._oldRemapper = null;
        this._remapPositions = null;
    }

    get width() {
        return this._width;
    }

    get height() {
        return this._height;
    }

    setSize(width, height) {
        this._width = width;
        this._height = height;
    }

    setTargetMask(targetMask) {
        this._targetMask = targetMask;
    }

    setRemapper(remapper) {
        this._remapper = remapper;
    }

    _updateRemapPositionsIfNeeded() {
        if (this._width !== this._oldWidth || this._height !== this._oldHeight || this._targetMask.width !== this._oldTargetWidth || this._targetMask.height !== this._oldTargetHeight || this._oldRemapper !== this._remapper) {
            this._oldWidth = this._width;
            this._oldHeight = this._height;
            this._oldTargetWidth = this._targetMask.width;
            this._oldTargetHeight = this._targetMask.height;
            this._oldRemapper = this._remapper;

            this._updateRemapPositions();
        }
    }

    _updateRemapPositions() {
        const { min, max, round } = Math;

        const width = this._width, height = this._height;
        const { width: tWidth, height: tHeight } = this._targetMask;
        const maxTx = tWidth-1, maxTy = tHeight-1;
        const transform = this._remapper.makeTransform();

        if (this._remapPositions === null || this._remapPositions.length !== width*height) {
            this._remapPositions = new Uint32Array(width*height);
        }
        const remapPositions = this._remapPositions;

        let pos = 0;
        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                let [tx, ty] = transform(x, y);
                tx = round(tx);
                ty = round(ty);
                tx = min(max(0, tx), maxTx);
                ty = min(max(0, ty), maxTy);

                remapPositions[pos++] = ty*tWidth+tx;
            }
        }
    }

    makeGetterAtPos() {
        this._updateRemapPositionsIfNeeded();

        const remapPositions = this._remapPositions;
        const getAtPos = this._targetMask.makeGetterAtPos();

        return (pos) => getAtPos(remapPositions[pos]);
    }
}

export default RemapCoordMask;
